<template>
  <div
    :class="{
      'from-primary-50 bg-gradient-to-b to-white to-[50vh]': !newHomeEnabled,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
const newHomeEnabled = useFeatureFlag("new_home");
</script>
